import { object, string, ref } from 'yup';

import getValidationTexts from 'common/utils/getValidationTexts';
import { emailRegex } from 'common/utils/helpers';

export default () => {
    const { REQUIRED_TEXT, EMAIL_VALIDATION_TEXT, EMAILS_DONT_MATCH } =
        getValidationTexts();

    return object().shape({
        first_name: string().required(REQUIRED_TEXT).nullable(),
        last_name: string().required(REQUIRED_TEXT).nullable(),
        business_name: string().required(REQUIRED_TEXT).nullable(),
        email: string()
            .required(REQUIRED_TEXT)
            .matches(emailRegex, EMAIL_VALIDATION_TEXT)
            .nullable(),
        confirm_email: string()
            .required(REQUIRED_TEXT)
            .matches(emailRegex, EMAIL_VALIDATION_TEXT)
            .oneOf([ref('email'), null], EMAILS_DONT_MATCH)
            .nullable(),
    });
};
